import { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";

import PortalDocumentsTable from "../components/PortalDocumentsTable.jsx";

/**
 * The full Dokumente list, with row selection for the zip download. See
 * PortalDocumentsTable.jsx for the table itself, including its own search
 * field.
 */
export default function DocumentListPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Übersicht", path: "/" },
      { name: "Dokumente", path: "/dokumente" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Dokumente
      </Typography>
      <PortalDocumentsTable selectable />
    </Box>
  );
}
